import Initialiser from 'initialiser';

// ACTION TYPES
const PUSH_TOAST = 'PUSH_TOAST';
const DISMISS_TOAST = 'DISMISS_TOAST';

// SYNC ACTION CREATORS
export function pushToast(toast) {
    return { type: PUSH_TOAST, toast };
}
export function dismissToast(title) {
    return { type: DISMISS_TOAST, title };
}
export function dismissAllToasts() {
    return { type: DISMISS_TOAST, title: null };
}

// REDUCER
export default function reducer(state = Initialiser.initialState.toaster, action) {
    switch (action.type) {
        case PUSH_TOAST: {
            return [action.toast].concat(state.slice());
        }
        case DISMISS_TOAST: {
            if (action.title === null) {
                return [];
            }
            const index = state && state.length > 0 ? state.map((toast) => toast.title).indexOf(action.title) : -1;
            if (index > -1) {
                state.splice(index, 1);
                return state.slice();
            }
            return state;
        }
        default: {
            return state;
        }
    }
}
